import { useEffect, useState } from "react";
import { FormModalDialog } from "../../../../components/ui";
import { getDateInLocalTZFromDateStr } from "../../../../utils/datetime";
import { getAddresses } from "../../../../services/api/dispatch";

/**
 * Allows users to select a custom address for a scope.
 *
 * @Note Coded by Ben and not refactored. Remains a bit messy and inconsistent, but
 * isn't too bad and it works well enough so left as is for time reasons.
 * 
 * @Note2 Ideally this would be a re-usable component combining at least time and 
 * address. If we have need for another component like this in future, take the time to
 * combine these and refactor in the process.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.scope - The scope object containing job details and custom address.
 * @param {boolean} props.open - A boolean indicating if the modal is open.
 * @param {Function} props.onClose - Function to call when the modal is closed.
 * @param {Function} props.onSubmit - Function to call when the form is submitted.
 * @returns {JSX.Element} The rendered component.
 */
export default function EditScopeCustomAddressModal({
  scope,
  open,
  onClose,
  onSubmit,
}) {
  const [formState, setformState] = useState(null);
  const [formValues, setFormValues] = useState(null);

  useEffect(() => {
    if (open && formValues === null) {
      getAddresses()
        .then((addresses) => {
          const activeAddresses = addresses.filter((address) => address.active);
          setFormValues({ addresses: activeAddresses });
        })
        .catch((e) => console.error(e));
    }
  }, [open, formValues]);

  useEffect(() => {
    if (open && formState === null && formValues !== null) {
      const address = formValues.addresses.find(
        (address) => address.address === scope["custom_address"]
      );
      const newState = {
        custom_address: address?.id || null,
      };

      setformState(newState);
    }
  }, [formState, formValues, open, scope]);

  useEffect(() => {
    if (!open && formState !== null) {
      setformState(null);
    }
  }, [formState, open]);

  const formattedDate = getDateInLocalTZFromDateStr(scope.date).toDateString();

  return (
    <FormModalDialog
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      title={"Select custom address"}
      descriptionSlot={
        <div>
          <span>Select a custom address for </span>
          <span>
            {scope.job.number} - {scope.job.description}
          </span>
          <span> on </span>
          <span>{formattedDate}</span>
        </div>
      }
      formSlot={
        formState &&
        formValues && (
          <div className={"flex flex-col space-y-2"}>
            <div>
              <select
                name="custom_address"
                defaultValue={formState["custom_address"]}
                className={
                  "rounded bg-white outline outline-1 outline-gray-300 focus:outline-2 focus:outline-sky-400 p-2 w-full"
                }
              >
                <option value={""}>Select an address</option>
                {formValues.addresses.map((address, index) => (
                  <option key={index} value={address.id}>
                    {address.address}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )
      }
    />
  );
}
